<script>
import IconComponent from './Icon.vue'

export default {
    // state
    props: {
        disabled: Boolean,
        icon: String,
        title: {
            default: null,
            type: [Object, String],
        },
        type: {
            default: 'button',
            type: String,
        },
    },
    // misc.
    components: {
        Icon: IconComponent,
    },
}
</script>

<template>
    <button
        class="
            tw:flex
            tw:items-center
            tw:p-0
            tw:bg-transparent
            tw:border-0
        "
        v-bind="{ title, type }"
        v-bind:disabled="disabled"
    >
        <Icon
            aria-hidden="true"
            v-bind="{ icon: icon, size: 'tw:w-full tw:h-full' }"
            v-bind:class="{
                'tw:fill-[#e0e1e2]': disabled,
                'tw:fill-vacatia-blue': !disabled,
                'tw:hover:fill-vacatia-blue-light': !disabled,
            }"
        />
    </button>
</template>
